import db from "@/database";

export const findAll = () => db.resolutionZone.toArray();
